import { css } from 'react-emotion';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import validate from './validate';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import AddContract from './AddContract';
import SelectExistingContract from './SelectExistingContract';
import { NEW, EXISTING } from './SelectPartyStep';
import { selectors as termSelectors } from '../../../../reducers/terms';
import isEmpty from 'lodash/isEmpty';
import Button from '../../../common/Button';
import { withTranslation } from 'react-i18next';

const buttonDivStyle = css({
  marginBottom: '50px',
  marginTop: '25px'
});

const prevButtonStyle = css({
  float: 'left'
});

const nextButtonStyle = css({
  float: 'right'
});

class AddContractDetailsStep extends Component {
  static propTypes = {
    onPrev: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    creationType: PropTypes.string
  };

  render() {
    const { handleSubmit, onPrev, creationType, termRevisionsByBuyerSeller, t } = this.props;

    let display;
    let prev = onPrev;

    switch (creationType) {
      case NEW:
        display = <AddContract />;
        prev = isEmpty(termRevisionsByBuyerSeller) ? () => onPrev({ numOfSteps: 2 }) : onPrev;
        break;
      case EXISTING:
        display = <SelectExistingContract contracts={termRevisionsByBuyerSeller} />;
        break;
      default:
        display = <div>{t('errors:error_general')}</div>;
    }

    return (
      <form onSubmit={handleSubmit}>
        {display}
        <div className={buttonDivStyle}>
          <span className={prevButtonStyle}>
            <Button className="btn btn-outline-primary" onClick={prev}>
              {t('common:commonWords.prev')}
            </Button>
          </span>
          <span className={nextButtonStyle}>
            <Button className="btn btn-primary">{t('common:commonWords.next')}</Button>
          </span>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  const formSelector = formValueSelector('buyerCreateFlow');

  const buyer = formSelector(state, 'buyer');
  const seller = formSelector(state, 'seller');
  return {
    creationType: formSelector(state, 'creationType'),
    termRevisionsByBuyerSeller: termSelectors.getTermRevisionsByBuyerSeller(state, buyer, seller)
  };
}

AddContractDetailsStep = connect(
  mapStateToProps,
  null
)(AddContractDetailsStep);

export default reduxForm({
  form: 'buyerCreateFlow',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(withTranslation()(AddContractDetailsStep));
